import { ColdIcon, WarmIcon, HotIcon, RemittanceIcon, InsuranceIcon, FinancingIcon, ReferralIcon, ReKYCIcon } from "../icons";

import { useState } from "react";
import LeadTableActions from "./leadTableActionButton";
import SidebarTabsContents from "./sidebar-components/leadSidebar.jsx";

const SharkTankTable = ({ data, totalPages, onLeadChange }) => {
    const [showSidebar, setShowSidebar] = useState(false);
    const [leadID, setLeadID] = useState(null);
    const [leadPipelineStage, setLeadPipelineStage] = useState(null);
    const [leadStatus, setLeadStatus] = useState(null);
    const [leadInterestLevel, setLeadInterestLevel] = useState(null);
    const [leadName, setLeadName] = useState(null);


    const handleDetailClick = (leadID) => {
      setShowSidebar(true);
      setLeadID(leadID);
      setLeadPipelineStage(data.find((item) => item.lead_id === leadID)?.status);
      setLeadStatus(data.find((item) => item.lead_id === leadID)?.lead_status);
      setLeadInterestLevel(data.find((item) => item.lead_id === leadID)?.interest_level);
      setLeadName(data.find((item) => item.lead_id === leadID)?.name);
    };
    const leadSourceLabels = {
        0: "Raw Lead",
        1: "Fresh Lead",
        2: "Profile Completed",
        3: "Meeting Completion",
        4: "Onboarded",
        5: "Activated",
        11: "Tanked",
    };
    const getStatusStyle = (status) => {
      const styles = {
          0: "bg-gray-100 text-gray-600",
          1: "bg-[#FEFAD8] border-[#FEFAD8] text-black",
          2: "bg-[#BEC2FF] border-[#BEC2FF] text-[#262BC6]",
          3: "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
          4: "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
          5: "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
          11: "bg-red-200 text-red-800"
      };
      return styles[status] || "bg-gray-100 text-gray-600";
    };
    const getLeadStatusStyle = (status) => {
      const styles = {
          Active: "bg-[#FEFAD8] border-[#FEFAD8] text-black",
          Ongoing: "bg-[#FFEEDC] border-[#FFEEDC] text-[#A96900]",
          Inactive: "bg-[#EEEEEE] border-[#EEEEEE] text-[#757575]",
          Tanked: "bg-[#757575] border-[#757575] text-[#EEEEEE]"
      };
      return styles[status] || "bg-gray-100 text-gray-600";
    };

    return (
      <><div className="">
        <table className="min-w-full bg-white border-b border-gray-200 table-fixed">
          <thead key="thead">
            <tr key="header-row" className="text-gray-400 border-t">
              <th key="header-id" className="p-4 border-b text-center w-[5%]">ID</th>
              <th key="header-product" className="p-4 border-b text-center w-[5%]">Product</th>
              <th key="header-name" className="p-4 border-b text-left w-[25%]">Name</th>
              <th key="header-status" className="p-4 border-b text-center w-[10%]">Lead Status</th>
              <th key="header-pipeline" className="p-4 border-b text-center w-[20%]">Pipeline Stage</th>
              <th key="header-source" className="p-4 border-b text-center w-[15%]">Lead Source</th>
              <th key="header-interaction" className="p-4 border-b text-center w-[15%]">Last Interacted</th>
              <th key="header-owner" className="p-4 border-b text-center w-[3%]">Owner</th>
              <th key="header-action" className="p-4 border-b text-center w-[2%]">Action</th>
            </tr>
          </thead>
          <tbody key="tbody">
            {data.length > 0 ? (
              data.map((item, index) => (
                <tr key={`row-${item.lead_id}-${index}`} 
                className="hover:bg-[#F7F7F7]"
                onClick={() => handleDetailClick(item.lead_id)}>
                  <td key={`id-${item.lead_id}`} className="p-4 border-b text-gray-500 text-center w-[5%]">{item.lead_id}</td>
                  <td key={`product-${item.lead_id}`} className="p-4 border-b text-center w-[5%]">
                    {item.products.includes('Remittance') && (
                      <img key={`remittance-${item.lead_id}`} src={RemittanceIcon} alt="Remittance" className="inline-block w-6 h-6 mr-2" />
                    )}
                    {item.products.includes('Insurance') && (
                      <img key={`insurance-${item.lead_id}`} src={InsuranceIcon} alt="Insurance" className="inline-block w-6 h-6 mr-2" />
                    )}
                    {item.products.includes('Financing') && (
                      <img key={`financing-${item.lead_id}`} src={FinancingIcon} alt="Financing" className="inline-block w-6 h-6 mr-2" />
                    )}
                    {item.products.includes('Referral') && (
                      <img key={`referral-${item.lead_id}`} src={ReferralIcon} alt="Referral" className="inline-block w-6 h-6 mr-2" />
                    )}
                    {item.products.includes('Re-KYC') && (
                      <img key={`rekyc-${item.lead_id}`} src={ReKYCIcon} alt="ReKYC" className="inline-block w-6 h-6 mr-2" />
                    )}
                  </td>
                  <td key={`name-${item.lead_id}`} className="p-4 border-b font-bold text-left w-[28%]">{item.name}</td>
                  <td key={`status-${item.lead_id}`} className="p-4 border-b text-center w-[10%]">
                    <span className={`w-[95px] h-[34px] pt-2 px-4 pb-2 gap-2 top-5 left-[22px] rounded-full border font-bold ${getLeadStatusStyle(item.lead_status)}`}>
                      {item.lead_status}
                    </span>
                  </td>
                  <td key={`pipeline-${item.lead_id}`} className="p-4 border-b text-center w-[20%]">
                    <span className={`w-[95px] h-[34px] pt-2 px-4 pb-2 gap-2 top-5 left-[22px] rounded-full border font-bold ${getStatusStyle(item.status)}`}>
                      {leadSourceLabels[item.status] || "Unknown"}
                    </span>
                  </td>
                  <td key={`source-${item.lead_id}`} className="p-4 border-b text-center w-[15%] font-bold">
                    <span key={`source-text-${item.lead_id}`} className="mr-2">{item.lead_source}</span>
                    {item.interest_level === 1 && <img key={`cold-${item.lead_id}`} src={ColdIcon} alt="Cold" className="w-6 h-6 inline-block gap-1" />}
                    {item.interest_level === 2 && <img key={`warm-${item.lead_id}`} src={WarmIcon} alt="Warm" className="w-6 h-6 inline-block gap-1" />}
                    {item.interest_level === 3 && <img key={`hot-${item.lead_id}`} src={HotIcon} alt="Hot" className="w-6 h-6 inline-block gap-1" />}
                  </td>
                  <td key={`interaction-${item.lead_id}`} className="p-4 border-b text-center w-[15%] font-bold">
                    {item.updated_time}
                    <span key={`last-interaction-${item.lead_id}`} className="text-xs text-[#A96900] border-[#FFEEDC] bg-[#FFEEDC] w-2 h-2 p-1 ml-2 rounded-full border">
                      {item.last_interacted}
                    </span>
                  </td>
                  <td key={`owner-${item.lead_id}`} className="p-4 border-b text-center w-[3%] font-bold">
                    <div className="relative group inline-block">
                      <span className="bg-[#EEEEEE] w-10 h-10 py-2 px-3 rounded-full inline-flex items-center justify-center">
                        {item.username ? item.username[0].toUpperCase() : ''}
                      </span>
                      <div className="absolute hidden group-hover:block bg-gray-800 text-white text-sm rounded py-1 px-2 -bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap">
                        {item.username ? item.username[0].toUpperCase() + item.username.slice(1) : 'No Owner'}
                      </div>
                    </div>
                  </td>
                  <td key={`action-${item.lead_id}`} onClick={(e) => e.stopPropagation()} className="p-4 border-b text-center w-[2%]">
                    
                    <LeadTableActions leadId={item.lead_id} leadName={item.name} onleadChange = {onLeadChange}/>
                  </td>
                </tr>
              ))
            ) : (
              <tr key="no-data-row">
                <td key="no-data-cell" colSpan="4" className="text-center py-4 text-gray-500 border-b">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <SidebarTabsContents
          showSidebar={showSidebar}
          setShowSidebar={setShowSidebar}
          leadID={leadID}
          leadPipelineStage={leadPipelineStage}
          leadStatus={leadStatus}
          leadInterestLevel={leadInterestLevel}
          leadName={leadName} />
          </>
    );
};
  
export default SharkTankTable;


